import { Injectable } from '@angular/core';
import { StoreConfig } from '@datorama/akita';
import { AbstractGitEntityStore } from '@y42/feature/git/state';
import { ExportTriggerGitFactoryService } from './export-trigger-git-factory.service';
import { ExportTriggerState } from './export-trigger.model';

const initialState: ExportTriggerState = {
  active: null,
  ui: {},
};

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'export-trigger', idKey: '$path' })
export class ExportTriggerStore extends AbstractGitEntityStore<ExportTriggerState> {
  constructor(protected readonly gitFactory: ExportTriggerGitFactoryService) {
    super({ name: 'Export-Trigger', gitFactory, initialState });
  }
}
